import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage, 
    DailySummaryDataActionTypes,
    GET_MASTERDATABYNAME, 
    GET_DAILYSUMMARY_DOMAIN_LIST_API,
    GET_DAILYSUMMARY_PROGRAM_LIST_API,
    GET_DAILYSUMMARY_TARGET_LIST_API,
    GET_BEHAVIOR_LIST_API,
    GET_DAILYSUMMARY_DATA,
    GET_DAILYSUMMARY_BEHAVIOR_DATA,
    UPDATE_DAILYSUMMARY_SKILLACQUISITION_DATA,
    UPDATE_DAILYSUMMARY_BEHAVIOR_DATA
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction';

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DailySummaryDataActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(DailySummaryDataActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const getDailySummaryDomainList = (searchObj, patientId, isAllRecordsRequired) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryDomainList.REQUEST));
        fetch(`${GET_DAILYSUMMARY_DOMAIN_LIST_API}${query_params}&patientId=${patientId}&isAllRecordsRequired=${isAllRecordsRequired || false}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryDomainList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryDomainList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_dailySummaryDomainList', error);
            });
    };
};

export const getDailySummaryProgramList = (searchObj, patientId, skillsAcquisitionDomainId, isAllRecordsRequired) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryProgramList.REQUEST));
        fetch(`${GET_DAILYSUMMARY_PROGRAM_LIST_API}${query_params}&patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionDomainId}&isAllRecordsRequired=${isAllRecordsRequired || false}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryProgramList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryProgramList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_dailySummaryProgramList', error);
            });
    };
};

export const getDailySummaryTargetList = (searchObj, patientId, skillsAcquisitionProgramId, isAllRecordsRequired, type,DomID) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryTargetList.REQUEST));

        let url = `${GET_DAILYSUMMARY_TARGET_LIST_API}${query_params}&patientId=${patientId}&skillsAcquisitionProgramId=${skillsAcquisitionProgramId}&isAllRecordsRequired=${isAllRecordsRequired || false}`;

        if(type == "DOMAIN"){
            url = `${GET_DAILYSUMMARY_TARGET_LIST_API}${query_params}&patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionProgramId}&isAllRecordsRequired=${isAllRecordsRequired || false}`;
        }else{
            url = `${GET_DAILYSUMMARY_TARGET_LIST_API}${query_params}&patientId=${patientId}&skillsAcquisitionProgramId=${skillsAcquisitionProgramId}&isAllRecordsRequired=${isAllRecordsRequired || false}&skillsAcquisitionDomainId=${DomID}`;
        }


        fetch(url, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryTargetList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryTargetList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_dailySummaryTargetList', error);
            });
    };
};

export const getBehaviorList = (searchObj, patientId, isAllRecordsRequired) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(DailySummaryDataActionTypes.get_behaviorList.REQUEST));
        fetch(`${GET_BEHAVIOR_LIST_API}${query_params}&patientId=${patientId}&isAllRecordsRequired=${isAllRecordsRequired || false}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_behaviorList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_behaviorList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviorList', error);
            });
    };
};

export const getDailySummaryData = (searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryData.REQUEST));
        fetch(`${GET_DAILYSUMMARY_DATA}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryData.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviorList', error);
            });
    };
};
export const getDailySummaryBehaviorData = (searchObj) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryBehaviorData.REQUEST));
        fetch(`${GET_DAILYSUMMARY_BEHAVIOR_DATA}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryBehaviorData.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DailySummaryDataActionTypes.get_DailySummaryBehaviorData.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_behaviorList', error);
            });
    };
};

export const updateDailySummarySkillAcquistionData = (skillsAcquisitionTargetId, value,Date) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(DailySummaryDataActionTypes.update_DailySummarySkillAcquisitionData.REQUEST));
  
        fetch(`${UPDATE_DAILYSUMMARY_SKILLACQUISITION_DATA}?skillsAcquisitionTargetId=${skillsAcquisitionTargetId}&value=${value}&date=${Date}`, {
        method: 'POST',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then((response) => {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);         
          } else {
            showErrorMessage(response.message);
          }
          dispatch(actionCreator(DailySummaryDataActionTypes.update_DailySummarySkillAcquisitionData.SUCCESS, response));
        }).catch(function(error) {
          console.log(error);
        });
    };    
  };


  export const updateDailyBehaviorData = (dailySummaryDataId, value,date) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(DailySummaryDataActionTypes.update_DailySummaryBehaviorData.REQUEST));
  
      fetch(`${UPDATE_DAILYSUMMARY_BEHAVIOR_DATA}?BehaviourReductionId=${dailySummaryDataId}&value=${value}&date=${date}`, {
        method: 'POST',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then((response) => {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);         
          } else {
            showErrorMessage(response.message);
          }
          dispatch(actionCreator(DailySummaryDataActionTypes.update_DailySummaryBehaviorData.SUCCESS, response));
        }).catch(function(error) {
          console.log(error);
        });
    };    
  };  

  


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/DailySummaryData/actions/DailySummaryDataActions.js